import React, { FunctionComponent } from 'react';
import { RiCalendar2Fill } from 'react-icons/ri';
import { AiOutlineMail } from 'react-icons/ai';
import { MdOutlinePhone } from 'react-icons/md';

import logo from '../../assets/logo.svg';
import './SystemDown.scss';
import { getFormattedDate } from '../../utils/systemMaintenanceUtils';

interface Props {
  restoreDate: string;
}

export const SystemDown: FunctionComponent<Props> = ({ restoreDate }) => (
  <div className="system-down-container">
    <div className="logo">
      <img src={logo} alt="Upstart logo" />
    </div>
    <div className="main-content">
      <h2>This system is currently unavailable due to planned maintenance</h2>
      <hr />
      <p>It will be available before working hours begin on:</p>
      <div className="restore-date">
        <RiCalendar2Fill size={18} style={{ marginRight: '11px' }} />
        <div>{getFormattedDate(new Date(restoreDate))}</div>
      </div>
    </div>
    <div className="footer">
      <p>Questions? Contact support</p>
      <hr />
      <div className="phone">
        <MdOutlinePhone size={18} style={{ marginRight: '11px' }} />
        <div>800-535-9749</div>
      </div>
      <div className="email">
        <AiOutlineMail size={18} style={{ marginRight: '10px' }} />
        <div>
          <a href="mailto:dealersupport@upstart.com">
            dealersupport@upstart.com
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default SystemDown;
